import React from 'react';
import NextButton from 'components/atoms/Button/NextButton';
import PrevButton from 'components/atoms/Button/PrevButton';
import ReturnTop from 'components/atoms/Button/ReturnTop';
import PcHowToDo from 'components/molecules/PcHowToDo';
import PcFloatingBanner from 'components/molecules/PcFloatingBanner';
import PcInputTitle from 'components/molecules/PcInputTitle';
import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcFreeInputArea from 'components/molecules/PcFreeInputArea';

import { ADD_CONF_URL, LP_URL } from 'utils/constant';

import './index.pc.scss';
import clsx from 'clsx';

const PcHowToDoArea = ({ bigTitle, headTitle, howToDoList }) => {
  const HowToDoButton = ({ howToDoList: detail }) => {
    return (
      <div className="">
        {detail.map((data) => (
          <PcHowToDo
            value={data.value}
            checked={data.checked}
            label={data.label}
            subLabel={data.subLabel}
            point={data.point}
            icon={data.icon}
            onChange={data.onChange}
            id={data.id}
          />
        ))}
      </div>
    );
  };


  return (
    <div className="PcHowToDoArea">
      <div className="contents">
        <span className="bigTitle">{bigTitle}</span>
        <span className="headTitle">{headTitle}</span>
        <div className="howtodoButtonArea">
          <HowToDoButton howToDoList={howToDoList} />
        </div>
      </div>
    </div>
  );
};

const InputArea = ({
  workInfoDips,
  workConditionsDisp,
  selectedDate,
  valid,
  onClickMainButton,

  workInfoRef,
  workConditionsRef,
}) => {
  return (
    <>
    <div className="switchArea">
      <div className="inputTitleArea">
        <div className="inputTitle">
          オンラインで追加入力を行いすぐに人選を開始する場合は <br />
          以下の内容を入力してください
        </div>
        <div className="dividingLine">
          <div className="downArrow" />
        </div>
      </div>
      <div className="inputArea" id="inputArea">
        <div id="workInfo" className="contents" ref={workInfoRef} >
          <div className="titleArea">
            <p className="title">勤務条件について教えてください</p>
          </div>
          <div className="workInfo">
            <div className="title">仕事内容を教えてください（複数選択可）</div>
            {workInfoDips.map((info) => {
              const { title, label, subTitle, list, type, comment, radioChild } = info;
              return (
                <PcInputTitle
                  title={title}
                  label={label}
                  subTitle={subTitle}
                  list={list}
                  type={type}
                  selectedDate={selectedDate}
                  comment={!comment?(<></>):(
                    <>
                      <PcFreeInputArea
                        visible={comment.visible}
                        title={comment.title}
                        label={comment.label}
                        questionMark={comment.questionMark}
                        popUpTitle={comment.popUpTitle}
                        popUpDetail={comment.popUpDetail}
                        relativePosArrow={comment.relativePosArrow}
                        name={comment.name}
                        textAreaValue={comment.textAreaValue}
                        cmntOnChange={comment.cmntOnChange}
                        onInput={comment.onInput}
                        onCompositionEnd={comment.onCompositionEnd}
                        maxLength={comment.maxLength}
                        placeholder={comment.placeholder}
                        rows={comment.rows}
                        cols={comment.cols}
                        wordCount={comment.wordCount}
                        errMessage={comment.errMessage}
                      />
                    </>
                  )}
                  radioChild={radioChild}
                />
              );
            })}
          </div>
        </div>
        <div id="workConditions" className="contents mT60" ref={workConditionsRef} >
          <div className="titleArea">
            <p className="title">職場情報について教えてください</p>
          </div>
          <div className="workConditions">
            {workConditionsDisp.map((info) => {
              const { title, label, subTitle, list, type, comment } = info;
              return (
                <PcInputTitle
                  title={title}
                  label={label}
                  subTitle={subTitle}
                  list={list}
                  type={type}
                  selectedDate={selectedDate}
                  comment={!comment?(<></>):(
                    <>
                      <PcFreeInputArea
                        visible={comment.visible}
                        title={comment.title}
                        label={comment.label}
                        questionMark={comment.questionMark}
                        popUpTitle={comment.popUpTitle}
                        popUpDetail={comment.popUpDetail}
                        relativePosArrow={comment.relativePosArrow}
                        name={comment.name}
                        textAreaValue={comment.textAreaValue}
                        cmntOnChange={comment.cmntOnChange}
                        onInput={comment.onInput}
                        onCompositionEnd={comment.onCompositionEnd}
                        maxLength={comment.maxLength}
                        placeholder={comment.placeholder}
                        rows={comment.rows}
                        cols={comment.cols}
                        wordCount={comment.wordCount}
                        errMessage={comment.errMessage}
                      />
                    </>
                  )}
                />
              );
            })}
          </div>
        </div>
        <div className="buttonArea">
          <NextButton
            label="次へ"
            link={ADD_CONF_URL}
            valid={valid}
            onClick={onClickMainButton.next}
          />
        </div>
      </div>
    </div>
    </>
  );
};

const FinishArea = ({ onClickMainButton}) => {
  return (
    <>
      <div className="finishArea">
        <div className="finishContent">
          担当者からご連絡の上、ヒアリングに基づき人選を開始します。
        </div>
        <div className="finishBtnArea">
          <PrevButton
            label="Topページへ戻る"
            link={LP_URL}
            valid="true"
            onClick={onClickMainButton.prev}
          />
        </div>
      </div>
    </>
  );
};

const FloatingBannerComp = ({ list, visible }) => {
  return (
    <>
      <div className={clsx('bannerArea', { show: visible }, { hide: !visible })}>
        {list.map((data) => (
          <PcFloatingBanner
            id={data.id}
            value={data.value}
            label={data.label}
            onChange={data.onChange}
            checked={data.checked}
          />
        ))}
      </div>
    </>
  );
};

const ReturnTopComp = ({returnTopDisp}) => {
  return (
    <div className={clsx('returnTopArea', { show: returnTopDisp.visible }, { hide: !returnTopDisp.visible })}>
      <ReturnTop onClick={returnTopDisp.onClick} />
    </div>
  )
};

const PresentPC = ({
  // 画面表示項目
  howToDo, // この後の進め方表示切替用値
  howToDoAreaDisp, // この後の進め方表示
  workInfoDips, // 仕事内容
  workConditionsDisp, // 勤務条件表示
  floatingBannerDisp,
  // onClick
  onClickMainButton,
  // APIエラー
  isApiError,
  // 選択済カレンダーデータ保持
  selectedDate,

  valid,

  showLoading,

  returnTopDisp,
  workInfoRef,
  workConditionsRef
}) => (
  <div className="BasicParent">
    <PcBasicTemplate
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      showLoading={showLoading}
    >
      <div className="AddInput">
        <div className="switchArea">
          <PcHowToDoArea
            bigTitle={howToDoAreaDisp.bigTitle}
            headTitle={howToDoAreaDisp.headTitle}
            howToDoList={howToDoAreaDisp.howToDoList}
            stepDescList={howToDoAreaDisp.stepDescList}
            howToDo={howToDo}

            onClickMainButton={onClickMainButton}
          />
        </div>
        {howToDo === '01' ? (
          <>
            <FloatingBannerComp list={floatingBannerDisp.list} visible={floatingBannerDisp.visible} />
            <InputArea
              workInfoDips={workInfoDips}
              workConditionsDisp={workConditionsDisp}
              selectedDate={selectedDate}
              valid={valid}
              onClickMainButton={onClickMainButton}
              workInfoRef={workInfoRef}
              workConditionsRef={workConditionsRef}
            />
            <ReturnTopComp returnTopDisp= {returnTopDisp} />
          </>
        ) : (
          <FinishArea onClickMainButton={onClickMainButton} />
        )}
      </div>
    </PcBasicTemplate>
  </div>
);

export default PresentPC;
